<template>
    <div class="setup-password">
      <h1>Set Your Password</h1>
      <div v-if="error">{{ error }}</div>
      <div v-else-if="!tokenValidated">
        <p>Validating invite...</p>
      </div>
      <div v-else>
        <p>Welcome, <strong>{{ username }}</strong>!</p>
        <form v-if="!registrationSuccess" @submit.prevent="submitPassword">
    <div>
        <label for="password">New Password:</label>
        <input id="password" v-model.trim="password" type="password" required minlength="6" />


    </div>
    <button type="submit" :disabled="isSubmitting">
  {{ isSubmitting ? 'Submitting...' : 'Set Password' }}
</button>

  </form>
  
    <p v-if="message">
    {{ message }}
    <template v-if="registrationSuccess">
  <br><br>
  <router-link :to="`/login?username=${encodeURIComponent(username)}`">
    Click here to log in
  </router-link>
</template>

  </p>
  
      </div>
    </div>
  </template>
  
  <script>
  import axios from 'axios';
  
  export default {
      
    name: 'SetupPassword',
    data() {
      return {
        token: '',
        username: '',
        password: '',
        tokenValidated: false,
        error: '',
        message: '',
        isSubmitting: false,
        registrationSuccess: false
      };
    },
    created() {
      this.token = this.$route.query.token;
      if (!this.token) {
        this.error = 'Invalid or missing token.';
        return;
      }
  
      axios.post('etherscan/validate_invite_token.php', { token: this.token })
        .then(res => {
          if (res.data.status === 'success') {
            this.username = res.data.username;
            this.tokenValidated = true;
          } else {
            this.error = res.data.message || 'Invalid or expired token.';
          }
        })
        .catch(() => {
          this.error = 'An error occurred while validating your invite.';
        });
    },
    methods: {
      submitPassword() {
        if (this.password.length < 6) {
  this.message = 'Password must be at least 6 characters.';
  return;
}
this.isSubmitting = true;


        axios.post('etherscan/complete_invite.php', {
          token: this.token,
          password: this.password
        })
        .then(res => {
          if (res.data.status === 'success') {

            this.registrationSuccess = true;
  this.message = 'Password set successfully! You can now log in.';
          } else {
            this.message = res.data.message || 'Something went wrong.';
          }
        })
        .catch(() => {
    this.message = 'An error occurred while completing your registration.';
  })
  .finally(() => {
    this.isSubmitting = false;
  });
      }
    }
  };
  </script>
  
  <style scoped>
  .setup-password {
    max-width: 400px;
    margin: 0 auto;
    padding: 1em;
  }
  </style>
  